import React, { forwardRef, ReactNode } from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { SxProps, Theme } from '@mui/material';
import { CoreFormControl, CoreFormControlProps } from "../core-form-control";
import { CoreInput } from '../core-input';

export type CoreNumberInputProps = CoreFormControlProps & Omit<NumericFormatProps, 'onChange' | 'size' | 'color'> & {
	color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
	size?: 'small' | 'medium';
	sx?: SxProps<Theme>;
	startAdornment?: ReactNode;
	onChange?(value: number | null): void;
};

export const CoreNumberInput = forwardRef<HTMLInputElement, CoreNumberInputProps>((props, ref) => {
	const {
		id,
		fullWidth,
		controlSx,
		label,
		labelSx,
		helperText,
		error,
		disabled,
		focused,
		requiredMark,
		controlId,
		onChange,
		...inputProps
	} = props;

	return (
		<CoreFormControl
			disabled={disabled}
			error={error}
			helperText={helperText}
			label={label}
			id={id}
			labelSx={labelSx}
			requiredMark={requiredMark}
			focused={focused}
			fullWidth={fullWidth}
			controlSx={controlSx}
			controlId={controlId}
		>
			<NumericFormat
				{...inputProps}
				id={id}
				customInput={CoreInput}
				onValueChange={({ value }) => {
					onChange?.(value ? +value : null);
				}}
				getInputRef={ref}
				valueIsNumericString
			/>
		</CoreFormControl>
	);
});

CoreNumberInput.displayName = 'CoreNumberInput';
